import React, { ReactNode } from 'react';
import { Element } from './RadioGroup.styles';
import { Text } from '@/components/typography';

export interface RadioGroupProps {
  label?: string;
  labelInfo?: string;
  className?: string;
  children?: ReactNode;
}

const RadioGroup = ({ label, labelInfo, children, ...props }: RadioGroupProps) => {
  return (
    <Element {...props}>
      {(label && (
        <Text weight="bold">
          {label}
          {labelInfo && <small> {labelInfo}</small>}
        </Text>
      )) ||
        null}
      <div>{children}</div>
    </Element>
  );
};

export default RadioGroup;
